<script>
  import { t } from '../i18n/index.js';
  import { showScreen } from '../stores/screen.js';

  function startPairing() {
    showScreen('pairing');
  }
</script>

<div class="screen flex flex-col h-full">
  <header class="p-6 text-center">
    <h1 class="text-3xl font-bold">{t('landing.title')}</h1>
    <p class="text-gray-400 mt-2">{t('landing.subtitle')}</p>
  </header>

  <main class="flex-1 flex flex-col items-center justify-center p-6 overflow-y-auto">
    <div class="max-w-md text-center">
      <!-- Start button - primary CTA at top -->
      <button
        onclick={startPairing}
        class="w-full py-4 mb-8 bg-blue-600 hover:bg-blue-500 rounded-xl font-semibold text-lg transition-colors"
      >
        {t('landing.startButton') || 'Start Scanning'}
      </button>

      <!-- Icon -->
      <div class="mb-8">
        <svg class="h-24 w-24 mx-auto text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
        </svg>
      </div>

      <!-- Description -->
      <h2 class="text-xl font-semibold mb-4">{t('landing.headline')}</h2>
      <p class="text-gray-400 mb-8 leading-relaxed">
        {@html t('landing.description')}
      </p>

      <!-- How to use -->
      <div class="text-left bg-gray-800 rounded-xl p-5 mb-8">
        <h3 class="font-semibold mb-3 text-center">{t('landing.howToUse')}</h3>
        <ol class="space-y-3 text-gray-300">
          <li class="flex items-start gap-3">
            <span class="flex-shrink-0 w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center text-sm font-bold">1</span>
            <span>{t('landing.step1')}</span>
          </li>
          <li class="flex items-start gap-3">
            <span class="flex-shrink-0 w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center text-sm font-bold">2</span>
            <span>{t('landing.step2')}</span>
          </li>
          <li class="flex items-start gap-3">
            <span class="flex-shrink-0 w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center text-sm font-bold">3</span>
            <span>{t('landing.step3')}</span>
          </li>
        </ol>
      </div>

      <!-- Download links -->
      <div class="mb-6">
        <p class="text-gray-500 text-sm mb-3">{t('landing.download')}</p>
        <div class="flex gap-3 justify-center">
          <a href="https://scantodesk.com/#download" target="_blank"
             class="px-5 py-3 bg-gray-700 hover:bg-gray-600 rounded-lg font-medium transition-colors flex items-center gap-2">
            <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            macOS
          </a>
          <a href="https://scantodesk.com/#download" target="_blank"
             class="px-5 py-3 bg-gray-700 hover:bg-gray-600 rounded-lg font-medium transition-colors flex items-center gap-2">
            <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 5.5L10.5 4.5V11.5H3V5.5ZM3 12.5H10.5V19.5L3 18.5V12.5ZM11.5 4.35L21 3V11.5H11.5V4.35ZM11.5 12.5H21V21L11.5 19.65V12.5Z"/>
            </svg>
            Windows
          </a>
        </div>
      </div>

      <!-- Note -->
      <p class="text-gray-500 text-sm">
        {@html t('landing.downloadNote')}
      </p>
    </div>
  </main>
</div>

<style>
  .screen {
    display: flex;
  }
</style>
